import { render, staticRenderFns } from "./League.vue?vue&type=template&id=5d0d4f7e&scoped=true&"
import script from "./League.vue?vue&type=script&lang=js&"
export * from "./League.vue?vue&type=script&lang=js&"
import style0 from "./League.vue?vue&type=style&index=0&id=5d0d4f7e&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d4f7e",
  null
  
)

export default component.exports